import { Box, useTheme } from "@mui/material";
import { PlanAncestors } from "components/common/planHistory/PlanAncestors";
import { buildMixIdChain } from "components/common/planHistory/mixAncestorChain";
import { useGetPlanAncestorsQuery } from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";
import { useMemo } from "react";

interface Props {
  planId: number;
  mixId: number;
}

export const HeatMixAncestors = ({ planId, mixId }: Props) => {
  const tenantName = useTenant();
  const { data, isLoading } = useGetPlanAncestorsQuery({
    tenantName,
    planId,
  });
  const theme = useTheme();

  const ancestors = useMemo(() => {
    if (data === undefined) return [];

    const relevantTargetMixIds = new Set(
      buildMixIdChain(data.ancestors, mixId).targets
    );

    return data.ancestors
      .map((planDifference) => ({
        ...planDifference,
        differences: planDifference.differences.filter((mixDifference) =>
          relevantTargetMixIds.has(mixDifference.target_mix_id)
        ),
      }))
      .filter((planDifference) => planDifference.differences.length > 0);
  }, [data, mixId]);

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        width: 250,
      }}
    >
      <PlanAncestors
        isLoading={isLoading || data === undefined}
        ancestors={ancestors}
      />
    </Box>
  );
};
